import { createFileRoute } from '@tanstack/react-router';
import { FormBuilderPage } from '@/features/forms/form-builder-page';

const TABS = ['build', 'share', 'submissions'] as const;
type Tab = (typeof TABS)[number];

export const Route = createFileRoute('/w/$workspaceId/forms/$formId')({
  // `?tab=` picks Build, Share or Submissions.
  validateSearch: (search: Record<string, unknown>): { tab?: Tab } => ({
    ...(TABS.includes(search.tab as Tab) ? { tab: search.tab as Tab } : {}),
  }),
  component: FormRoute,
});

function FormRoute() {
  const { formId } = Route.useParams();
  const { tab } = Route.useSearch();
  return <FormBuilderPage key={formId} formId={formId} tab={tab} />;
}
